<template lang="html">

  <b-form @submit.prevent="save" style="padding-left:12px;padding-right:12px;padding-top:17px;padding-bottom:17px">
    <div class="row" >
      <div class="col-md-3">
        <b-form-group label="Tipo*">
          <b-select v-model="form.type">
            <option value="client">Cliente/Fornitore</option>
            <option value="partner">Partner</option>
            <option v-if="$store.user.type == 'admin'" value="admin">Amministratore</option>
          </b-select>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Nome*">
          <b-form-input v-model="form.name" required />
        </b-form-group>
      </div>
      <div class="col-md-3">
          <b-form-group label="Cognome*">
            <b-form-input v-model="form.surname" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-3">
          <b-form-group label="Azienda*">
            <b-form-input v-model="form.company" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-12">
        <b-form-group label="Immagine/Logo Azienda">
          <file-uploader v-model="form.images" accept="image/*"/>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Email*">
          <b-form-input v-model="form.email" required />
        </b-form-group>
      </div>
      <div class="col-md-4">
          <b-form-group label="Telefono*">
            <b-form-input v-model="form.phone_number" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-4">
          <b-form-group label="P.IVA*">
            <b-form-input v-model="form.vat_number" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-4">
          <b-form-group label="Regione*">
            <b-form-select v-model="form.region" :options="region_options"></b-form-select>
          </b-form-group>
      </div>
      <div class="col-md-4">
          <b-form-group label="Indirizzo*">
            <b-form-input v-model="form.addr_street" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-3">
          <b-form-group label="Città*">
            <b-form-input v-model="form.addr_city" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-3">
          <b-form-group label="Provincia (Sigla)*">
            <b-form-input v-model="form.addr_prov" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-2">
          <b-form-group label="CAP*">
            <b-form-input v-model="form.addr_zip" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-12" v-if="$store.user.type == 'admin'">
          <b-form-group label="CODICE PARTNER">
            <b-form-input v-model="form.user_code" :disabled="$store.user.type != 'admin'" requiredasd />
          </b-form-group>
      </div>
      <div class="col-md-12" v-if="$store.user.type == 'admin'">
        <b-form-group label="Note:">
          <b-form-textarea rows="5" v-model="form.notes" requiredasd />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="font-size:12px;">
        Tutti i campi contrassegnaticon * sono obbligatori
      </div>
    </div>
    <!-- {{form}} -->

    <div class="text-right">
      <b-button variant="outline-danger" @click="$emit('close')">Annulla</b-button>
      &nbsp;
      <b-button type="submit" variant="primary">Salva</b-button>
    </div>
  </b-form>
</template>

<script>
import FileUploader from '@/components/file-uploader'
export default {
  components: {
    FileUploader,
  },
  data(){
    return {
      region_selected: null,
      region_options: [
        { value: 'Abruzzo', text: 'Abruzzo'},
        { value: 'Basilicata', text: 'Basilicata'},
        { value: 'Calabria', text: 'Calabria'},
        { value: 'Campania', text: 'Campania'},
        { value: 'Emilia-Romagna', text: 'Emilia-Romagna'},
        { value: 'Friuli-Venezia Giulia', text: 'Friuli-Venezia Giulia'},
        { value: 'Lazio', text: 'Lazio'},
        { value: 'Liguria', text: 'Liguria'},
        { value: 'Lombardia', text: 'Lombardia'},
        { value: 'Marche', text: 'Marche'},
        { value: 'Molise', text: 'Molise'},
        { value: 'Piemonte', text: 'Piemonte'},
        { value: 'Puglia', text: 'Puglia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Sicilia', text: 'Sicilia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Toscana', text: 'Toscana'},
        { value: 'Trentino-Alto Adige', text: 'Trentino-Alto Adige'},
        { value: 'Umbria', text: 'Umbria'},
        { value: "Val d'aosta", text: "Val d'aosta"},
        { value: 'Veneto', text: 'Veneto'}
      ]
    }
  },
  props: ['form'],
  methods: {
    save() {
      this.$http.post('users', this.form).then(res => {
        this.$emit('saved', res.data)
        this.$emit('close')
      })
    },
  },
}
</script>

<style lang="css" scoped>
</style>
